import { render, staticRenderFns } from "./AppRecommendeProductsForProductsModal.vue?vue&type=template&id=4b5b44bc&scoped=true"
import script from "./AppRecommendeProductsForProductsModal.vue?vue&type=script&lang=js"
export * from "./AppRecommendeProductsForProductsModal.vue?vue&type=script&lang=js"
import style0 from "./AppRecommendeProductsForProductsModal.vue?vue&type=style&index=0&id=4b5b44bc&prod&lang=css"
import style1 from "./AppRecommendeProductsForProductsModal.vue?vue&type=style&index=1&id=4b5b44bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b44bc",
  null
  
)

export default component.exports